import { useAuth } from '../context/AppContext';

/**
 * Hook to check user permissions
 * Returns permission flags and a helper function to check any permission
 */
export const usePermissions = () => {
  const { user: currentUser } = useAuth();

  const permissions = currentUser?.permissions || null;

  // Individual permission flags
  const canApproveStudents = permissions?.canApproveStudents === true;
  const canManageClubs = permissions?.canManageClubs === true;
  const canViewAnalytics = permissions?.canViewAnalytics === true;
  const canManagePosts = permissions?.canManagePosts === true;

  // Allowed branches
  const allowedBranches = permissions?.allowedBranches || [];

  // Helper function to check any permission
  const hasPermission = (permissionKey: string): boolean => {
    if (!permissions) return false;
    return (permissions as any)[permissionKey] === true;
  };

  // Helper to check if user can access a specific branch
  const canAccessBranch = (branch: string): boolean => {
    if (!allowedBranches || allowedBranches.length === 0) return false;
    return allowedBranches.includes(branch);
  };

  // Role-based helpers (for backward compatibility)
  const isFaculty = currentUser?.role === 'Faculty';
  const isAmbassador = currentUser?.role === 'Ambassador';
  const isStudent = currentUser?.role === 'Student';

  return {
    // Permission flags
    canApproveStudents,
    canManageClubs,
    canViewAnalytics,
    canManagePosts,
    allowedBranches,

    // Helper functions
    hasPermission,
    canAccessBranch,

    // Role flags (for backward compatibility)
    isFaculty,
    isAmbassador,
    isStudent,

    // Raw permissions object
    permissions,
  };
};

export default usePermissions;
